"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.oxfordComma = void 0;

function oxfordComma(items) {
  if (items.length === 1) return items[0];

  var itemsClone = _toConsumableArray(items);

  var lastItem = itemsClone.pop();
  return itemsClone.join(', ') + ", and ".concat(lastItem);
}

exports.oxfordComma = oxfordComma;